import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchDashboardStats = createAsyncThunk(
  'dashboard/fetchStats',
  async () => {
    const [tradeStats, pnlSummary] = await Promise.all([
      api.get('/api/trade-history/statistics/'),
      api.get('/api/pnl-history/summary/')
    ]);
    return {
      tradeStats: tradeStats.data,
      pnlSummary: pnlSummary.data
    };
  }
);

export const fetchActiveData = createAsyncThunk(
  'dashboard/fetchActiveData',
  async () => {
    const [activeTriggers, tradingPairs] = await Promise.all([
      api.get('/api/triggers/active_triggers/'),
      api.get('/api/trading-pairs/', { params: { is_active: true } })
    ]);
    return {
      activeTriggers: activeTriggers.data,
      activeTradingPairs: tradingPairs.data
    };
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    tradeStats: {
      total_trades: 0,
      buy_trades: 0,
      sell_trades: 0,
      total_volume: 0,
      total_volume_usdt: 0,
      total_fees: 0,
      avg_price: 0,
    },
    pnlSummary: {
      total_pnl: 0,
      total_fee: 0,
      trade_count: 0,
      avg_premium: 0,
    },
    activeTriggers: [],
    activeTradingPairs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.tradeStats = action.payload.tradeStats;
        state.pnlSummary = action.payload.pnlSummary;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchActiveData.fulfilled, (state, action) => {
        state.activeTriggers = action.payload.activeTriggers;
        state.activeTradingPairs = action.payload.activeTradingPairs.results || action.payload.activeTradingPairs;
      });
  },
});

export default dashboardSlice.reducer;